module.exports = __webpack_public_path__ + "assets/img/KeyReport_Cannes.4809dfc4-ps.jpg";